import axios from 'axios';

// En Electron se sobreescribe con la URL guardada (ver initServerUrl).
// En navegador queda vacío para usar rutas relativas al mismo origen
// (así el build web funciona sin cambios sin importar el dominio donde se sirva).
let SERVER_URL = '';

// ── Caché local de datos (para modo sin conexión) ─────────────────────────────
const CACHE_KEY_GESTIONES = 'cache_gestiones';
const CACHE_KEY_USER      = 'cache_user';

export function saveGestionesCache(data) {
  try { localStorage.setItem(CACHE_KEY_GESTIONES, JSON.stringify({ data, ts: Date.now() })); } catch {}
}
export function loadGestionesCache() {
  try {
    const raw = localStorage.getItem(CACHE_KEY_GESTIONES);
    if (!raw) return null;
    return JSON.parse(raw).data;
  } catch { return null; }
}
export function saveUserCache(user) {
  try { localStorage.setItem(CACHE_KEY_USER, JSON.stringify(user)); } catch {}
}
export function loadUserCache() {
  try {
    const raw = localStorage.getItem(CACHE_KEY_USER);
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}

// Cargar URL del servidor desde Electron si está disponible
export async function initServerUrl() {
  if (window.electronAPI) {
    SERVER_URL = (await window.electronAPI.getServerUrl()).replace(/\/+$/, '');
  }
}

export function getServerUrl() { return SERVER_URL; }

export async function setServerUrl(url) {
  SERVER_URL = url.replace(/\/+$/, '');
  if (window.electronAPI) await window.electronAPI.setServerUrl(SERVER_URL);
}

function getToken() { return localStorage.getItem('token'); }

function client() {
  return axios.create({
    baseURL: SERVER_URL + '/api',
    headers: { Authorization: `Bearer ${getToken()}` }
  });
}

// Auth
export const login = (usuario, password) =>
  axios.post(`${SERVER_URL}/api/auth/login`, { usuario, password }).then(r => r.data);

export const cambiarPassword = (passwordActual, passwordNuevo) =>
  client().post('/auth/cambiar-password', { passwordActual, passwordNuevo }).then(r => r.data);

export const refreshToken = () =>
  client().post('/auth/refresh').then(r => r.data);
// Usuarios
export const getUsuarios = () => client().get('/usuarios').then(r => r.data);
export const crearUsuario = (data) => client().post('/usuarios', data).then(r => r.data);
export const actualizarUsuario = (id, data) => client().put(`/usuarios/${id}`, data).then(r => r.data);
export const eliminarUsuario = (id) => client().delete(`/usuarios/${id}`).then(r => r.data);

// Gestiones
export const getGestiones = () => client().get('/gestiones').then(r => r.data);
export const crearGestion = (data) => client().post('/gestiones', data).then(r => r.data);

// Sesiones
export const crearSesion = (gestionId, data) =>
  client().post(`/gestiones/${gestionId}/sesiones`, data).then(r => r.data);
export const actualizarSesion = (id, data) => client().put(`/sesiones/${id}`, data).then(r => r.data);
export const eliminarSesion = (id) => client().delete(`/sesiones/${id}`).then(r => r.data);
export const getPlazo = (id) => client().get(`/sesiones/${id}/plazo`).then(r => r.data);
export const setOverride = (id, activo) => client().put(`/sesiones/${id}/override`, { activo }).then(r => r.data);

// Documentos
export const getDocumentos = (sesionId) =>
  client().get(`/sesiones/${sesionId}/documentos`).then(r => r.data);

export const subirDocumentos = (sesionId, archivos, onProgress) => {
  const form = new FormData();
  archivos.forEach(f => form.append('pdfs', f));
  return client().post(`/sesiones/${sesionId}/documentos`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: e => onProgress && onProgress(Math.round(e.loaded * 100 / e.total))
  }).then(r => r.data);
};

export const eliminarDocumento = (id) => client().delete(`/documentos/${id}`).then(r => r.data);

export const urlVerDoc = (id) => `${SERVER_URL}/api/documentos/${id}/ver?token=${getToken()}`;
export const urlDescargar = (id) => `${SERVER_URL}/api/documentos/${id}/descargar?token=${getToken()}`;

// Descarga forzando el guardado real del archivo en el navegador.
// window.open(url) con Content-Disposition: attachment es inconsistente entre
// navegadores (a veces termina mostrando el PDF en la pestaña en vez de bajarlo).
// Bajar el archivo como blob y disparar un <a download> es el método confiable.
export async function descargarEnNavegador(url, nombreArchivo) {
  const resp = await fetch(url);
  if (!resp.ok) throw new Error('No se pudo descargar el archivo');
  const blob = await resp.blob();
  const blobUrl = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = blobUrl;
  a.download = nombreArchivo || 'documento.pdf';
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(blobUrl);
}

// Búsqueda
export const buscar = (params) => client().get('/buscar', { params }).then(r => r.data);

// Pendientes
export const getPendientes = () => client().get('/pendientes').then(r => r.data);
export const subirPendientes = (archivos, descripcion, onProgress) => {
  const form = new FormData();
  archivos.forEach(f => form.append('pdfs', f));
  if (descripcion) form.append('descripcion', descripcion);
  return client().post('/pendientes', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: e => onProgress && onProgress(Math.round(e.loaded * 100 / e.total))
  }).then(r => r.data);
};
export const eliminarPendiente = (id) => client().delete(`/pendientes/${id}`).then(r => r.data);
export const moverPendiente = (id, sesion_id) => client().post(`/pendientes/${id}/mover`, { sesion_id }).then(r => r.data);
export const moverTodosPendientes = (ids, sesion_id) => client().post('/pendientes/mover-todos', { ids, sesion_id }).then(r => r.data);
export const urlVerPendiente = (id) => `${getServerUrl()}/api/pendientes/${id}/ver?token=${getToken()}`;
export const urlDescargarPendiente = (id) => `${getServerUrl()}/api/pendientes/${id}/descargar?token=${getToken()}`;
